import { useNavigateTo } from 'hooks/useNavigateTo'
import {
  StyledAnimatedIcon,
  StyledBase64Img,
  StyledIcon,
  ToolbarButton,
  ToolbarButtonTextGroup,
  ToolbarElement,
  UploaderWrapper,
} from './Styled'
import likeAnimationData from './animated-icons/like.json'
import saveAnimationData from './animated-icons/save.json'
import shareIconImg from '@theme/short-player-ui/share.svg'
import { formatCountCN } from 'utils/formatCountCN'
import React, { useCallback } from 'react'
import { useToastAlert } from 'hooks/useToastAlert'

interface ToolbarHomeProps {
  liked?: boolean
  saved?: boolean
  likeCount?: number
  saveCount?: number
  onLike?: () => void
  onSave?: () => void
  onShare?: () => void
  uploaderIcon?: string
  uploaderId?: string
}

const ToolbarHome: React.FC<ToolbarHomeProps> = ({
  liked = false,
  saved = false,
  likeCount = 0,
  saveCount = 0,
  onLike,
  onSave,
  onShare,
  uploaderIcon,
  uploaderId,
}) => {
  const { navigateToViewUploader } = useNavigateTo()
  const {toast} = useToastAlert()
  const toUploaderPage = useCallback(() => {
    if (uploaderId && uploaderId !== '0') {
      navigateToViewUploader({ uploaderId })
    }
    else{
      toast('该视频无UP主资料')
    }
  }, [navigateToViewUploader, toast, uploaderId])
  return (
    <ToolbarElement>
      <UploaderWrapper onClick={toUploaderPage}>
        <StyledBase64Img src={uploaderIcon}></StyledBase64Img>
      </UploaderWrapper>
      <ToolbarButton onClick={() => onLike?.()}>
        <StyledAnimatedIcon animationData={likeAnimationData} active={liked}></StyledAnimatedIcon>
        <ToolbarButtonTextGroup>{formatCountCN(likeCount)}</ToolbarButtonTextGroup>
      </ToolbarButton>
      <ToolbarButton onClick={() => onSave?.()}>
        <StyledAnimatedIcon animationData={saveAnimationData} active={saved}></StyledAnimatedIcon>
        <ToolbarButtonTextGroup>{formatCountCN(saveCount)}</ToolbarButtonTextGroup>
      </ToolbarButton>
      <ToolbarButton onClick={() => onShare?.()}>
        <StyledIcon $icon={shareIconImg} />
      </ToolbarButton>
    </ToolbarElement>
  )
}

export default ToolbarHome
